import { Component } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
    selector: 'confirmation-modal',
    templateUrl: './confirmation-modal.component.html',
    styleUrls: ['confirmation-modal.component.scss'],
    standalone: false
})
export class ConfirmationModalComponent {
  public modalTitle: string;
  public modalMessage: string;
  public modalConfirmDisabled = false;
  // Notify confirm as been triggered
  public onConfirmSubject: Subject<any>;

  constructor() {
    // Notify confirm has been triggered
    this.onConfirmSubject = new Subject();
  }

  /**
   * @function confirm
   * @description Emit modal confirm für alle Subscribers
   */
  public confirm() {
    this.onConfirmSubject.next(true);
  }

  /**
   * @function decline
   * @description Emit modal decline für alle Subscribers
   */
  public decline() {
    this.onConfirmSubject.next(false);
  }
}
